/* NR — Buscador predictivo (desktop flydown + móvil takeover). Motor propio sobre la Predictive Search API de Shopify.
   Progressive enhancement: sin JS, el <form> sigue yendo a /search.
   Estados: vacío (server-rendered, "Más buscados" + "Lo más vendido") vs predictiva (sección nr-predictive-search inyectada).
   Spec: docs/contexto/spec-buscador-nr-v2.md */
(function () {
  var root = document.querySelector('[data-nr-search]');
  if (!root) return;

  var input    = root.querySelector('[data-nr-search-input]');
  var panel    = root.querySelector('[data-nr-search-panel]');
  var empty    = root.querySelector('[data-nr-search-empty]');
  var results  = root.querySelector('[data-nr-search-results]');
  var clearBtn = root.querySelector('[data-nr-search-clear]');
  var cancelBtn = root.querySelector('[data-nr-search-close]');
  var openBtn  = document.querySelector('[data-nr-search-open]'); // lupa (móvil), fuera del wrapper
  if (!input || !panel || !results) return;

  var SECTION = 'nr-predictive-search';
  var MIN = 2;
  var DEBOUNCE = 200;
  var controller = null;
  var timer = null;
  var lastQuery = '';

  function isMobileOpen() { return root.classList.contains('is-mobile-open'); }

  function openPanel() {
    if (root.classList.contains('is-open')) return;
    panel.hidden = false;
    root.classList.add('is-open');
    input.setAttribute('aria-expanded', 'true');
  }
  function closePanel() {
    panel.hidden = true;
    root.classList.remove('is-open');
    input.setAttribute('aria-expanded', 'false');
  }
  function showEmpty()  { if (empty) empty.hidden = false; results.hidden = true; }
  function showResults(){ if (empty) empty.hidden = true;  results.hidden = false; }

  function reflectState() {
    input.value.trim().length >= MIN ? showResults() : showEmpty();
  }

  // ----- Takeover móvil -----
  function openMobile() {
    root.classList.add('is-mobile-open');
    document.body.classList.add('nr-search-lock');
    panel.hidden = false;
    reflectState();
    setTimeout(function () { input.focus(); }, 40); // tras el paint → sube el teclado
  }
  function closeMobile() {
    root.classList.remove('is-mobile-open');
    document.body.classList.remove('nr-search-lock');
    closePanel();
    input.blur();
  }

  // ----- Predictiva -----
  function fetchResults(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    root.classList.add('is-loading');
    var url = '/search/suggest?q=' + encodeURIComponent(q) +
              '&section_id=' + SECTION +
              '&resources[type]=product,query,collection&resources[limit]=6';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-nr-fly-inner]');
        results.innerHTML = inner ? inner.innerHTML : '';
        root.classList.remove('is-loading');
        showResults();
      })
      .catch(function (e) {
        if (e.name !== 'AbortError') { root.classList.remove('is-loading'); showEmpty(); }
      });
  }

  function onInput() {
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = q.length === 0;
    if (q.length < MIN) {
      if (timer) { clearTimeout(timer); timer = null; }
      lastQuery = '';
      showEmpty();
      return;
    }
    if (q === lastQuery) { showResults(); return; }
    lastQuery = q;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { fetchResults(q); }, DEBOUNCE);
  }

  // ----- Listeners -----
  input.addEventListener('focus', function () { openPanel(); reflectState(); });
  input.addEventListener('input', onInput);

  if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); openMobile(); });
  if (cancelBtn) cancelBtn.addEventListener('click', function () { closeMobile(); });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      lastQuery = '';
      showEmpty();
      input.focus();
    });
  }

  document.addEventListener('click', function (e) {
    if (isMobileOpen()) return;                 // el takeover se cierra con Cancelar / Esc
    if (!root.contains(e.target)) closePanel();
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { isMobileOpen() ? closeMobile() : (closePanel(), input.blur()); }
  });

  // Navegación con flechas por los enlaces visibles del panel
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = Array.prototype.slice.call(panel.querySelectorAll('a'))
      .filter(function (a) { return a.offsetParent !== null; });
    if (!links.length) return;
    e.preventDefault();
    var i = links.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') i = i < links.length - 1 ? i + 1 : 0;
    else i = i > 0 ? i - 1 : links.length - 1;
    links[i].focus();
  });
})();
